import {
  CONFIGURATION_PATH,
  DASHBOARD_PATH,
  HEALTH_PLANS_PATH,
  HOUSING_DATABASE_PATH,
  HOUSING_EXPENSE_CREATE_REQUEST_PATH,
  HOUSING_EXPENSE_REQUEST_PATH,
  LOGIN_PATH,
  Members_PATH,
  RESET_PASSWORD_PATH,
  SURVEY_HISTORY_PATH,
  USERS_PATH,
} from "constants/routePaths";
import Dashboard from "containers/dashboard";
import HousingDatabase from "containers/housing-database";
import HousingExpenseRequest from "containers/housing-expense-requests";
import CreateHousingExpense from "containers/housing-expense-requests/create";
import Login from "containers/login";
import Members from "containers/members";
import Reset from "containers/reset-password";
import SurveyHistory from "components/survey/SurveyHistory";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Protected from "routes/Protected";
import LCMHealthPlans from "containers/lcm-healthplans";
import Users from "containers/users/Index";
import Configuration from "containers/configuration/Index";

const AppRoutes = ({ isLoggedIn }) => {
  return (
    <Routes>
      {/* Guest Routes */}
      <Route path={LOGIN_PATH} element={<Login />} />
      <Route path={RESET_PASSWORD_PATH} element={<Reset />} />

      {/* Protected Routes */}
      <Route
        path={DASHBOARD_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <Dashboard />
          </Protected>
        }
      />
      <Route
        path={Members_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <Members />
          </Protected>
        }
      />
      <Route
        path={SURVEY_HISTORY_PATH}
        element={
          <Protected visibleSidebar={false} isLoggedIn={isLoggedIn}>
            <SurveyHistory />
          </Protected>
        }
      />
      <Route path="/survey/history/:id" element={<SurveyHistory />} />
      <Route
        path={HOUSING_EXPENSE_REQUEST_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <HousingExpenseRequest />
          </Protected>
        }
      />
      <Route
        path={HOUSING_EXPENSE_CREATE_REQUEST_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <CreateHousingExpense />
          </Protected>
        }
      />
      <Route
        path={HOUSING_DATABASE_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <HousingDatabase />
          </Protected>
        }
      />
      <Route
        path={HEALTH_PLANS_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <LCMHealthPlans />
          </Protected>
        }
      />

      <Route
        path={USERS_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <Users />
          </Protected>
        }
      />
      <Route
        path={CONFIGURATION_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <Configuration />
          </Protected>
        }
      />
    </Routes>
  );
};
export default AppRoutes;
